var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item._kind === 'created')?_c('betriebsanweisungProofStatus',{attrs:{"item":_vm.item}}):_c('span',{staticClass:"grey--text"},[_vm._v("–")])
}
var staticRenderFns = []

export { render, staticRenderFns }